import React from "react";
import { useNavigate } from "react-router-dom";
import "./exam-submitted.css"; // Import the CSS file

const ExamCompleted = () => {
  const navigate = useNavigate();

  return (
    <div className="Exam-Card-Box">
      <div className="exam-card">
      <h2 className="exam-title">Exam Completed</h2>
      <p className="exam-message">Exam availability has ended.</p>

      <div className="exam-buttons">
        <button className="exam-button dashboard-btn" onClick={() => navigate("/")}>
          Go to Dashboard
        </button>
      </div>
       </div>
    </div>
    
  );
};

export default ExamCompleted;
